import * as types from './StatisticsActionTypes';
import Api from '../StatisticsApi';

export function resetState() {
    return (dispatch: (result: any) => void) => dispatch({ type: types.STATISTICS_RESET });
}

function newSearchSuccess(result: any) {
    return { type: types.NEW_STATISTICS_SEARCH, result: result };
}

export function newSearch() {
    return (dispatch: (result: any) => void) =>
        Api.newSearch().then((result: any) => {
            dispatch(newSearchSuccess(result));
        });
}

function searchSuccess(result: any) {
    return { type: types.STATISTICS_SEARCH, result: result };
}

export function search(data: any) {
    return (dispatch: (result: any) => void) =>
        Api.search(data).then((result: any) => {
            dispatch(searchSuccess(result));
        });
}

export function exportExcel(data: any) {
    return (dispatch: (result: any) => void) => Api.exportExcel(data);
}
